import { cn } from '@lyearn/style';

import { smallMediumIconStyles } from '../Buttons/utils/styles';
import { linkButtonFocusStyles, linkButtonInverseFocusStyles } from './styles';
import {
  LinkButtonColor,
  LinkButtonFontWeight,
  LinkButtonIconSize,
  LinkButtonSize,
  LinkButtonTextProps,
} from './types';

const className = 'p-0 hover:bg-transparent disabled:opacity-50 min-w-0';

const COLOR_CONFIG: Record<LinkButtonColor, string> = {
  external: cn(
    'text-link-external hover:text-link-external-hover active:text-link-external-active disabled:text-link-external',
    linkButtonFocusStyles,
  ),
  internal: cn(
    'text-link-internal hover:text-link-internal-hover active:text-link-internal-active disabled:text-link-internal',
    linkButtonFocusStyles,
  ),
  inverse: cn(
    'text-link-white hover:text-link-white-hover active:text-link-white-active disabled:text-link-white',
    linkButtonInverseFocusStyles,
  ),
};

const ICON_SIZE_CONFIG: Record<LinkButtonIconSize, string> = {
  large: 'w-24 h-24',
  medium: 'w-20 h-20',
  small: 'w-16 h-16',
};

interface GetLinkButtonIconClassesParams {
  color: LinkButtonColor;
  size: LinkButtonIconSize;
}

export const getLinkButtonIconClasses = (params: GetLinkButtonIconClassesParams) => {
  const { color, size } = params;

  return {
    icon: ICON_SIZE_CONFIG[size],
    root: cn(className, COLOR_CONFIG[color]),
  };
};

const TYPOGRAPHY_VARIANT_CONFIG: Record<LinkButtonFontWeight, Record<LinkButtonSize, string>> = {
  heading: {
    medium: 'heading-xs',
    small: 'heading-xxs',
  },
  label: {
    medium: 'label-01',
    small: 'label-02',
  },
};

interface GetLinkButtonClassesParams {
  color: LinkButtonColor;
  fontWeight: LinkButtonFontWeight;
  size: LinkButtonSize;
  typography: LinkButtonTextProps['typography'];
}

export const getLinkButtonClasses = (params: GetLinkButtonClassesParams) => {
  const { color, fontWeight, size, typography } = params;
  const gapX = size === 'small' ? 'gap-x-6' : 'gap-x-8';
  const typographyVariant = typography?.variant ?? TYPOGRAPHY_VARIANT_CONFIG[fontWeight][size];

  return {
    root: cn(className, gapX, typographyVariant, smallMediumIconStyles, COLOR_CONFIG[color]),
  };
};
